import { render, staticRenderFns } from "./ModalKelolaPeserta.vue?vue&type=template&id=1235e404&"
import script from "./ModalKelolaPeserta.vue?vue&type=script&lang=js&"
export * from "./ModalKelolaPeserta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports